// Federal Generator Status Thresholds
export const LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = 1;
export const LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = 2.2;

export const VSQG_THRESHOLD_HAZARDOUS_KG = 0;
export const VSQG_THRESHOLD_HAZARDOUS_LB = 0;

export const SQG_THRESHOLD_HAZARDOUS_KG = 100;
export const SQG_THRESHOLD_HAZARDOUS_LB = 220;

export const LQG_THRESHOLD_HAZARDOUS_KG = 1000;
export const LQG_THRESHOLD_HAZARDOUS_LB = 2200;

// Kansas Small Quantity Generator
export const KSQG_THRESHOLD_HAZARDOUS_LB = 55;
// Texas Class 1 Only Threshold
export const TEXAS_CLASS_1_ONLY_LB = 220;

// Federal on-site accumulation caps (40 CFR 262.14/262.16) — the maximum
// hazardous waste a generator may hold on site at any time, distinct from the
// monthly generation-rate thresholds above. LQGs have no federal quantity cap
// (their accumulation is time-limited instead).
export const VSQG_ON_SITE_CAP_KG = 1000;
export const VSQG_ON_SITE_ACUTE_CAP_KG = 1;
export const SQG_ON_SITE_CAP_KG = 6000;
